export const lang = {
  drawer: {
    heading: "Task Options",
    useTags: "Use Tags",
    useNotes: "Use Notes",
    useTaskPriority: "Use Task Priority",
    addTaskOnEnter: "Add new task on pressing Enter",
    autoCompleteOnTimer: "Mark task complete when timer runs out",
    defaultTaskDuration: "Default Task Duration:",
    defaultTaskDurationOptions: {
      fifteenMinutes: "15 minutes",
      twentyMinutes: "20 minutes",
      thirtyMinutes: "30 minutes",
    },
    wipeAll: "Wipe All",
    saveAll: "Save All",
    importData: "Import Data",
    cleanUpCompletedTasks: "Clean Up Completed Tasks",
    saveOnBrowserClose: "Save data to local storage on browser close",
    settings: "Settings",
    showLegend: "Show Legend",
    showClocks: "Show World Clocks",
    clockTimeFormat: "Clock Time Format:",
    clockTimeFormatOptions: {
      twelveHour: "12-hour (AM/PM)",
      twentyFourHour: "24-hour",
    },
    clockFontTheme: "Clock Font:",
    clockFontThemeOptions: {
      default: "Default",
      digital: "Digital",
    },
  },
  app: {
    addMainTask: "Add Main Task",
    addDeadlineTask: "Add Deadline Task",
    fiveMinRest: "5 Min Rest",
    thirtyMinRest: "30 Min Rest",
    focusedTab: "Focused",
    todoTab: "To-Do Lists",
    flashCardsTab: "Flash Cards", // New
    addList: "+ Add List",
    addBookList: "+ Add Book List",
    addClock: "Add Clock",
    removeClock: "Remove Clock",
    localTimezoneLabel: "Local",
  },
  taskColumn: {
    mainTasks: "Main Tasks",
    subtasksOf: "Subtasks of",
    bulkTaskInputPlaceholder: "Enter tasks (comma-separated)",
  },
  task: {
    newTask: "New Task",
    newSubtask: "New Subtask",
    restTask: "Rest",
    minutes: "min",
    timeInputPlaceholder: "00:30",
    playAlt: "Play",
    pauseAlt: "Pause",
    resetAlt: "Reset",
    addSubtaskAlt: "Add Subtask",
    deleteAlt: "Delete",
    notesAlt: "Notes",
    deadlineAlt: "Set Deadline",
    collapse: "Collapse",
    expand: "Expand",
    days: "days",
    hours: "hours",
    placeholder: "Enter task name",
    priorityLabel: "Priority",
  },
  tagControls: {
    tagInputPlaceholder: "Add tags (comma-separated), press Enter",
    clearFilter: "Clear Filter",
  },
  flashCards: {
    // New section for Flash Cards
    addTopic: "Create New Topic",
    topicNamePlaceholder: "Enter Topic Name...",
    addCard: "Add Flash Card",
    frontLabel: "Front (Question/Statement):",
    backLabel: "Back (Answer):",
    categoriesLabel: "Categories:",
    categoryInputPlaceholder: "Add categories (comma-separated)",
    difficultyLabel: "Difficulty:",
    difficultyLevels: {
      easy: "Easy",
      moderate: "Moderate",
      hard: "Hard",
      mildPanic: "Mild Panic", // Updated
      gotcha: "Gotcha!",
      none: "None",
    },
    viewAsStack: "Stack View",
    viewAsGrid: "Grid View",
    shuffleCards: "Shuffle Cards",
    nextCard: "Next",
    prevCard: "Previous",
    flipCard: "Flip Card",
    manageCategories: "Manage Categories",
    filterByCategory: "Filter by Category:",
    filterByDifficulty: "Filter by Difficulty:",
    allCategories: "All Categories",
    allDifficulties: "All Difficulties",
    columnsLabel: "Columns:",
  },
  wipeModal: {
    heading: "Wipe All Data",
    message:
      "Are you sure you want to wipe all data? This action cannot be undone.",
    confirm: "Confirm",
    cancel: "Cancel",
  },
  import: {
    error: "Failed to import data. Please ensure the file is a valid JSON.",
  },
  todoList: {
    newList: "New List",
    titlePlaceholder: "Enter book title",
    lastNamePlaceholder: "Author last name",
    firstNamePlaceholder: "Author first name",
  },
  deadlineModule: {
    heading: "Upcoming Deadlines",
  },
  legend: {
    heading: "Icon Legend",
    play: "Play: Start the task timer.",
    pause: "Pause: Pause the task timer.",
    reset: "Reset: Reset the task timer to its original duration.",
    addSubtask: "Add Subtask: Create a subtask under this task.",
    delete: "Delete: Remove this task.",
    notes: "Notes: Add or view notes for this task.",
    deadline: "Deadline: Set or edit a deadline for this task.",
  },
  notesModal: {
    title: "Edit Notes",
    save: "Save",
    cancel: "Cancel",
  },
};
